import { Badge } from "@/components/ui/badge";
import type { ScanStatus } from "@site-migrator/shared";
import { cn } from "@/lib/utils";

const STATUS_STYLES: Record<ScanStatus, string> = {
    pending: "bg-muted text-muted-foreground",
    running: "bg-blue-500/15 text-blue-700 dark:text-blue-300",
    completed: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
    failed: "bg-destructive/15 text-destructive",
    cancelled: "bg-orange-500/15 text-orange-700 dark:text-orange-300",
    queued: "bg-muted text-muted-foreground",
};

export const STATUS_DOT_CLASSES: Record<ScanStatus, string> = {
    pending: "bg-muted-foreground/40",
    running: "bg-blue-500",
    completed: "bg-emerald-500",
    failed: "bg-destructive",
    cancelled: "bg-orange-500",
    queued: "bg-muted-foreground/40",
};

const STATUS_LABELS: Record<ScanStatus, string> = {
    pending: "Pending",
    running: "Running",
    completed: "Completed",
    failed: "Failed",
    cancelled: "Cancelled",
    queued: "Queued",
};

export function ScanStatusBadge({ status, className }: { status: ScanStatus; className?: string }) {

    return (
        <Badge variant="outline" className={cn(STATUS_STYLES[status], "border-transparent", className)}>
            {STATUS_LABELS[status]}
        </Badge>
    );
}
